import isEmpty from 'lodash/isEmpty';
import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';

export function fetchFeedbackTypes() {
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.FEEDBACK_TYPES}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}

export function submitFeedback(options) {
  return new Promise((resolve, reject) => {
    if (isEmpty(options)) reject(new Error('invalid params'));
    else {
      APIService.request(
        {
          method: 'POST',
          data: options,
          url: `${API_HOST}${apiEndpoints.FEEDBACK}`,
        },
        (error, data) => {
          if (error) {
            reject(error);
          } else if (data) {
            resolve(data);
          } else {
            resolve(null);
          }
        }
      );
    }
  });
}

export function fetchFeedbackStatus() {
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.FEEDBACK}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data.length > 0) {
          resolve(true);
        } else {
          resolve(null);
        }
      }
    );
  });
}
